import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AuthService } from '../../root/auth.service';

@Component({
  selector: 'lohi-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopnavComponent implements OnInit, OnDestroy {
  public title$ = new BehaviorSubject<string | null>(null);
  public icon$ = new BehaviorSubject<'arrow_back_ios' | 'menu' | 'none' | null>('none');
  public showIcon$ = new BehaviorSubject(true);
  @Output() public toggle = new EventEmitter();

  private subscriptions: Subscription[] = [];
  public showLogo$$ = new BehaviorSubject(false);

  constructor(private router: Router, private location: Location, private authService: AuthService) {}

  public ngOnInit() {
    this.subscriptions.push(
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.showIcon$.next(true);
        this.showLogo$$.next(false);
        switch (event.url) {
          case '/pickup/pickup':
            this.title$.next(null);
            this.showIcon$.next(false);
            break;
          case '/pickup/detail':
            this.title$.next(null);
            this.icon$.next('arrow_back_ios');
            break;
          case '/pickup/confirm-unhitch':
            this.title$.next('Confirm Couple');
            this.icon$.next('arrow_back_ios');
            break;
          case '/pickup/plate-preview':
            this.title$.next('Trailer Submission');
            this.icon$.next('arrow_back_ios');
            break;
          case '/pickup/write-in-plate-preview':
            this.title$.next('Trailer Submission');
            this.icon$.next('arrow_back_ios');
            break;
          case '/pickup/examine':
            this.title$.next('Look it over');
            this.icon$.next('arrow_back_ios');
            break;
          case '/pickup/submit':
            this.title$.next('Submitting...');
            this.icon$.next(null);
            break;
          case '/pickup/report-damage':
            this.title$.next('Report Damage');
            this.icon$.next('arrow_back_ios');
            break;
          case '/pickup/thank-you':
            this.showIcon$.next(false);
            this.title$.next(null);
            break;
          case '/dropoff/checkin':
            this.title$.next(null);
            this.showIcon$.next(false);
            break;
          case '/dropoff/dropoff':
            this.title$.next(null);
            this.icon$.next('arrow_back_ios');
            break;
          case '/dropoff/report-damage':
            this.title$.next('Report Damage');
            this.icon$.next('arrow_back_ios');
            break;
          case '/dropoff/confirm-unhitch':
            this.title$.next('Confirm Uncouple');
            this.icon$.next('arrow_back_ios');
            break;
          case '/dropoff/plate-preview':
            this.title$.next('Trailer Number');
            this.icon$.next('arrow_back_ios');
            break;
          case '/dropoff/examine':
            this.title$.next('Inspect');
            this.icon$.next('arrow_back_ios');
            break;
          case '/dropoff/submit':
            this.title$.next('Submitting...');
            this.icon$.next(null);
            break;
          case '/dropoff/thank-you':
            this.showIcon$.next(false);
            this.title$.next(null);
            break;
          default:
            this.showIcon$.next(true);
            this.title$.next(null);
            this.icon$.next('menu');
            this.showLogo$$.next(true);
            break;
        }
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public navigationAction() {
    this.icon$.pipe(take(1)).subscribe((icon) => {
      if (icon !== null) {
        if (icon === 'arrow_back_ios') {
          this.location.back();
        } else if (icon === 'menu') {
          this.toggle.next();
        }
      }
    });
  }

  public logout() {
    this.authService.logout();
  }
}
